import React from "react";
import type { GridProps } from "./GridTypes";
import GridHybrid from "./GridHybrid";

/**
 * Grid component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using a
 * styled() extension or styled-system props).
 */
const Grid: React.FC<GridProps> = (props) => <GridHybrid {...props} />;

Grid.displayName = "Grid";
export default Grid;
